import React, {useEffect, useRef, useState} from "react";
import GenericTemplate from "../../templates/GenericTemplate";
import {ApolloMessage, CustomizedSnackbars} from "../../atom/Apollo_Mesasge"
import {Backdrop, Button, Card, CardContent, colors, Grid, MuiThemeProvider, Table, TableBody} from "@material-ui/core";
import {apollo_useStyles} from "../../atom/Apollo_styles";
import {Bars} from "react-loader-spinner";
import {ApolloBasicSelect} from "../../molecule/Apollo_BaseItem";
import {useForm} from "react-hook-form";
import moment from "moment";
import {
    apollo_operation_history_account_names,
    apollo_operation_history_adgroup_names,
    apollo_operation_history_campagine_names,
    apollo_operation_log
} from "../../atom/Apollo_links";
import {createMuiTheme} from "@material-ui/core/styles";
import {STORAGE_KEY} from "../../atom/Apollo_DataTable";
import MUIDataTable, {MUISortOptions} from "mui-datatables";
import {APOLLO_PAGE_ID, createApolloPageSizeTableOptions} from "../../common/Apollo_LocalStorageSettings";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import Paper from "@material-ui/core/Paper";
import TableHead from "@material-ui/core/TableHead";
import {ApolloAxios} from "../../atom/Apollo_ApiRequest3";
import {ApolloContext} from "../../atom/Apollo_Context";
import {
    APOLLO_GROUP_ADMIN, APOLLO_GROUP_OPERATOR,
    APOLLO_PROFILE_SYSTEM_ADMIN,
    APOLLO_PROFILE_SYSTEM_OPERATOR,
    ApolloPageUsagePermission
} from "../../atom/Apollo_Authorization";
import ApolloDateRangePicker from "../../atom/Apollo_DateRangePicker";
import {addDays, endOfDay, startOfDay} from "date-fns";
import {ApolloBreadcrumbs} from "../../atom/Apollo_Breadcrumbs";
import {convertBrTag, formatApolloCsvCell} from "../../common/Apollo_CommonUtil";

const BLANK = ""
const UNDER_SCORE = "_"
const HYPHEN = "-"
const EQUAL = "="
const SEMI_COLON = ";"
const FULL_COMMA = "、"
const FULL_EQUAL = "＝"
const COMMA = ","
const SLASH = "/"
const SPACE = " "

type AccountList = {
    id: number;
    name: string;
}

type CampaignList = {
    id: number;
    parentId: number;
    name: string;
    platform: number;
    platformAccountId: number;
}

type AdGroupList = {
    id: number;
    parentId: number;
    name: string;
    platform: number;
}

type historyDataRow = {
    date: string;
    name: string;
    accountName: string;
    pfmenu: number;
    campaignName: string;
    adGroupName: string;
    target: string;
    operationKbn: string;
    targetColumns: string[];
    editDetails: editDetail[];
}

type editDetail = {
    columName: string;
    beforeValue: string;
    afterValue: string;
}

const OPERATION_KBN = {
    create: "作成",
    update: "更新",
    delete: "削除",
    copy: "複製",
}

const KBN_None = 0
const KBN_1 = 1
const KBN_2 = 2
const KBN_3 = 3

const BUTTON_SEARCH = 1
const BUTTON_CSV_DOWNLOAD = 2

const CATEGORY = [
    {
        KBN_NO: KBN_None,
        LABEL: BLANK,
        TARGET: [],
        CSV_HEADER: [],
        TABLE_OPTIONS: []
    },
    {
        KBN_NO: KBN_1,
        LABEL: "ユーザ管理",
        TARGET: ["user"],
        CSV_HEADER: [
            "操作日時",
            "操作ユーザ氏名",
            "対象",
            "操作内容",
            "項目名",
            "変更前",
            "変更後"
        ],

        TABLE_OPTIONS: [
            {
                name: "date",
                label: "操作日時",
                options: {
                    filter: true,
                    sort: true,
                }
            },
            {
                name: "name",
                label: "操作ユーザ氏名",
                options: {
                    filter: true,
                    sort: true,
                }
            },
            {
                name: "target",
                label: "対象",
                options: {
                    filter: true,
                    sort: true,
                }
            }, {
                name: "operationKbn",
                label: "操作内容",
                options: {
                    filter: true,
                    sort: true,
                }
            },
            {
                name: "targetColumns",
                label: "項目名",
                options: {
                    filter: true,
                    sort: true,
                }
            },
        ]
    },
    {
        KBN_NO: KBN_2,
        LABEL: "アカウント管理、案件管理",
        TARGET: ["account", "campaign", "adGroup", "advertisement", "crAsset"],
        CSV_HEADER: [
            "操作日時",
            "操作ユーザ氏名",
            "広告アカウント名",
            "メニュー",
            "キャンペーン名",
            "広告グループ名",
            "対象",
            "操作内容",
            "項目名",
            "変更前",
            "変更後"
        ],
        TABLE_OPTIONS: [
            {
                name: "date",
                label: "操作日時",
                options: {
                    filter: true,
                    sort: true,
                }
            },
            {
                name: "name",
                label: "操作ユーザ氏名",
                options: {
                    filter: true,
                    sort: true,
                }
            },
            {
                name: "accountName",
                label: "広告アカウント名",
                options: {
                    filter: true,
                    sort: true,
                }
            }, {
                name: "pfmenu",
                label: "メニュー",
                options: {
                    filter: true,
                    sort: true,
                }
            }, {
                name: "campaignName",
                label: "キャンペーン名",
                options: {
                    filter: true,
                    sort: true,
                }
            }, {
                name: "adGroupName",
                label: "広告グループ名",
                options: {
                    filter: true,
                    sort: true,
                }
            }, {
                name: "target",
                label: "対象",
                options: {
                    filter: true,
                    sort: true,
                }
            }, {
                name: "operationKbn",
                label: "操作内容",
                options: {
                    filter: true,
                    sort: true,
                }
            },
            {
                name: "targetColumns",
                label: "項目名",
                options: {
                    filter: true,
                    sort: true,
                }
            },
        ]
    },
    {
        KBN_NO: KBN_3,
        LABEL: "広告主アイコン管理",
        TARGET: ["adClientIcon"],
        CSV_HEADER: [
            "操作日時",
            "操作ユーザ氏名",
            "広告アカウント名",
            "メニュー",
            "キャンペーン名",
            "広告グループ名",
            "対象",
            "操作内容",
            "項目名",
            "変更前",
            "変更後"
        ],
        TABLE_OPTIONS: [
            {
                name: "date",
                label: "操作日時",
                options: {
                    filter: true,
                    sort: true,
                }
            },
            {
                name: "name",
                label: "操作ユーザ氏名",
                options: {
                    filter: true,
                    sort: true,
                }
            },
            {
                name: "accountName",
                label: "広告アカウント名",
                options: {
                    filter: true,
                    sort: true,
                }
            }, {
                name: "pfmenu",
                label: "メニュー",
                options: {
                    filter: true,
                    sort: true,
                }
            }, {
                name: "campaignName",
                label: "キャンペーン名",
                options: {
                    filter: true,
                    sort: true,
                }
            }, {
                name: "adGroupName",
                label: "広告グループ名",
                options: {
                    filter: true,
                    sort: true,
                }
            }, {
                name: "target",
                label: "対象",
                options: {
                    filter: true,
                    sort: true,
                }
            }, {
                name: "operationKbn",
                label: "操作内容",
                options: {
                    filter: true,
                    sort: true,
                }
            },
            {
                name: "targetColumns",
                label: "項目名",
                options: {
                    filter: true,
                    sort: true,
                }
            },
        ]
    },
]

const TARGET_MIN_DAY = startOfDay(addDays(new Date(), -90))
const TARGET_MAX_DAY = endOfDay(new Date())

const TIME_ENDCHAR = "T"

const CRLF = "\r\n"

const CHAR_DAY = "day"
const CHAR_DAYS = "days"

const MIME_CSV = 'text/csv'


const TIME_FORMAT_PATTERN1 = "YYYYMMDDHHmmss"
const TIME_FORMAT_PATTERN2 = "YYYY-MM-DDTHH:mm:ss"
const TIME_FORMAT_PATTERN3 = "YYYY-MM-DD"

const BEFORE_ITEMS = 1;
const AFTER_ITEMS = 2;

const RESULT_KBN = {
    SUCCESS: 0,
    INFO: 1,
    ERROR: -9,
    BADREQUEST: -1,
}

const PAST_DAY = -6

const MSG = {
    ERR_GET_ACCOUNTS: "広告主アカウントリスト取得に失敗しました。",
    ERR_GET_CAMPAIGNS: "キャンペーンリスト取得に失敗しました。",
    ERR_GET_ADGROUPS: "広告グループリスト取得に失敗しました。",
    ERR_GET_OPERATONLOGS: "ユーザ操作ログ取得に失敗しました。",
}

const PF_MENU_PERFORMANCE = "パフォーマンス広告"
const CATEGORY_CAMPAIGNS = "キャンペーン"
const LABEL_AD_CAMPAIGN_EXCLUDING_DOMAINS = "配信先ドメイン除外設定"
const LABEL_AD_CAMPAIGN_TARGET_DOMAINS = "配信先ドメイン指定設定"
const VALUE_SETTING = {
    EXISTS: "設定あり",
    NOT_EXISTS: "設定なし",
}


const INIT_START_DATE = moment().add(PAST_DAY, CHAR_DAYS).startOf(CHAR_DAY).format(TIME_FORMAT_PATTERN3)
const INIT_END_DATE = moment().startOf(CHAR_DAY).format(TIME_FORMAT_PATTERN3)

const extractItems = (dataRows: any, itemKbn: number) => {

    let pfMenu =　dataRows.pfmenu;
    let target =　dataRows.target;

    return dataRows.editDetails.filter?.((elem: any) => elem?.beforeValue !== elem?.afterValue)?.map?.(
        (elem: any) => {
            let columName =　elem.columName;
            let tempValue = itemKbn === BEFORE_ITEMS ? elem.beforeValue : elem.afterValue
            let editedStr;
            if(pfMenu ==　PF_MENU_PERFORMANCE && target == CATEGORY_CAMPAIGNS && (columName == LABEL_AD_CAMPAIGN_EXCLUDING_DOMAINS || columName == LABEL_AD_CAMPAIGN_TARGET_DOMAINS)) {
                editedStr = tempValue.length > 0 ? VALUE_SETTING.EXISTS : VALUE_SETTING.NOT_EXISTS;
            } else {
                editedStr =　tempValue.replace(/[\r\n\t]/g, SPACE)
                    .replace(/,/g, FULL_COMMA)
                    .replace(/=/g, FULL_EQUAL)
            }
            return `${elem.columName}${EQUAL}${editedStr}`
        }
    )?.join(SEMI_COLON) ?? BLANK
}

const createCsv = (rows: historyDataRow[], kbn: number) => {

    let historyRows = rows.map((row) => {

        let dataRows: any = []
        let targetColumns: any = "";
        const beforeConverted = row.operationKbn === OPERATION_KBN.update ? extractItems(row, BEFORE_ITEMS) : BLANK
        const afterConverted = row.operationKbn === OPERATION_KBN.update ?  extractItems(row, AFTER_ITEMS) : BLANK

        if(typeof row.targetColumns === "string") {
            targetColumns = formatApolloCsvCell(row.targetColumns, true);
        }else {
            targetColumns = row.targetColumns
        }

        if (kbn === KBN_1) {
            dataRows = [
                formatApolloCsvCell(row.date),
                formatApolloCsvCell(row.name, true),
                formatApolloCsvCell(row.target, true),
                formatApolloCsvCell(row.operationKbn),
                targetColumns,
                formatApolloCsvCell(beforeConverted, true),
                formatApolloCsvCell(afterConverted, true),
            ]
        } else if (kbn === KBN_2) {
            dataRows = [
                formatApolloCsvCell(row.date),
                formatApolloCsvCell(row.name, true),
                formatApolloCsvCell(row.accountName, true),
                formatApolloCsvCell(row.pfmenu),
                formatApolloCsvCell(row.campaignName, true),
                formatApolloCsvCell(row.adGroupName, true),
                formatApolloCsvCell(row.target, true),
                formatApolloCsvCell(row.operationKbn),
                targetColumns,
                formatApolloCsvCell(beforeConverted, true),
                formatApolloCsvCell(afterConverted, true),
            ]
        } else if (kbn === KBN_3) {
            dataRows = [
                formatApolloCsvCell(row.date),
                formatApolloCsvCell(row.name, true),
                formatApolloCsvCell(row.accountName, true),
                formatApolloCsvCell(row.pfmenu),
                formatApolloCsvCell(row.campaignName, true),
                formatApolloCsvCell(row.adGroupName, true),
                formatApolloCsvCell(row.target, true),
                formatApolloCsvCell(row.operationKbn),
                targetColumns,
                formatApolloCsvCell(beforeConverted, true),
                formatApolloCsvCell(afterConverted, true),
            ]
        }

        return dataRows
    }) ?? [[]];

    const sortedRows = historyRows.sort(function(a : any, b : any){
        return moment(b[0]).diff(moment(a[0]))
    });

    const csvHeader = CATEGORY[kbn].CSV_HEADER?.map(column => formatApolloCsvCell(column));

    const blob = dataToCsvBlob(sortedRows, csvHeader)
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = `${moment().format(TIME_FORMAT_PATTERN1)}.csv`;
    link.click();
}

const dataToCsvBlob = (data: any[][], header: any[]): Blob => {
    let csvData = BLANK;
    data?.map((line, index1) => {
        let csvData1 = BLANK
        line?.map((column, index2) => {
            if (index2 === 0) {
                csvData1 = column;
            } else {
                csvData1 = csvData1 + COMMA + column;
            }
            return csvData1;
        });
        csvData = csvData + csvData1 + CRLF;
    });
    csvData = header + CRLF + csvData;
    const bom = new Uint8Array([0xEF, 0xBB, 0xBF])

    const blob = new Blob([bom, csvData], {
        type: MIME_CSV
    })
    return blob
}

const OperationHistoryList: React.FC = () => {

    // context
    const {data: msg, setmsg} = React.useContext(ApolloMessage);
    const {state: apolloContex} = React.useContext(ApolloContext);

    // useStyle
    const classes = apollo_useStyles();

    // useForm
    const {
        handleSubmit,
        control,
        errors,
        setValue,
    } = useForm({reValidateMode: 'onBlur'});

    // state
    const [sortOrder, setSortOrder] = useState<MUISortOptions>({
        name: "date",
        direction: 'desc',
    })
    const [numberOfRows, setNumberOfRows] = useState(10)

    const [accountList, setAccountList] = useState<AccountList[]>([])
    const [campaignList, setCampaignList] = useState<CampaignList[]>([])
    const [adGroupList, setAdGroupList] = useState<AdGroupList[]>([])

    const [category, setCategory] = useState<number>(KBN_2)

    const [selectedAccounts, setSelectedAccounts] = useState<number[]>([])
    const [selectedCampaigns, setSelectedCampaigns] = useState<string[]>([])
    const [selectedAdGroups, setSelectedAdGroups] = useState<string[]>([])

    const [startDate, setStartDate] = useState(INIT_START_DATE)
    const [endDate, setEndDate] = useState(INIT_END_DATE)

    const [rows, setRows] = useState<historyDataRow[]>([]);

    // etc
    const [progress, setProgress] = useState(true);

    // useRef
    const buttonType = React.useRef(0);

    const isD2cUser = useRef(apolloContex.userprofile.systemAdmin === APOLLO_PROFILE_SYSTEM_ADMIN
        || apolloContex.userprofile.systemAdmin === APOLLO_PROFILE_SYSTEM_OPERATOR);

    const isAdminRole = useRef(apolloContex.current.roleAuthorization === APOLLO_GROUP_ADMIN);

    const selectCategory =
        [
            {label: isD2cUser.current ? "アカウント管理、案件管理" : "案件管理", value: KBN_2},
/*            {label: "ユーザ管理", value: KBN_1}*/　// ユーザ管理機能のリリースが延期された為、リストに出力しないようにする
            {label: "広告主アイコン管理", value: KBN_3},
        ]

    const selectCategoryFiltered = React.useRef(
        selectCategory.filter((elem: any) => {
                return isD2cUser.current || isAdminRole.current ? true : elem.value !== KBN_1　
            }
        ));

    const tableTheme = createMuiTheme({
        palette: {
            primary: {
                main: colors.blue[300],
                light: '#fff',
                contrastText: '#fff',
            },
        },
    });

    const optionsAccountList =
        accountList?.map(account => ({
            value: account.id,
            label: account.name
        }))

    //選択されていない要素の親リストは除外する。
    const optionsCampaignList =
        campaignList?.filter(list => selectedAccounts.includes(list.parentId)).map(list => ({
            value: `${list.platform}${UNDER_SCORE}${list.id}`,
            label: `${list.id}${UNDER_SCORE}${list.name}`
        }))

    //選択されていない要素の親リストは除外する。
    const optionsAdGroupList =
        adGroupList?.filter(list => selectedCampaigns.includes(`${list.platform}${UNDER_SCORE}${list.parentId}`)).map(list => ({
            value: `${list.platform}${UNDER_SCORE}${list.id}`,
            label: `${list.id}${UNDER_SCORE}${list.name}`
        }))

    // 広告主アカウント一覧取得
    useEffect(() => {
        setProgress(true);
        const pathAccount = `${apollo_operation_history_account_names}/${apolloContex.current.accountGroupId}`;
        ApolloAxios.get(pathAccount).then(response => {
            if (response.data.resultCode === RESULT_KBN.SUCCESS) {
                const resData = response?.data?.result || []
                setAccountList(resData.map((account: any) => {
                        return {
                            id: account.id,
                            name: account.name,
                        }
                    }
                ))
            } else {
                setmsg({
                    type: "setMessage",
                    payload: {
                        ...msg,
                        open: true,
                        type: "error",
                        message: `${MSG.ERR_GET_ACCOUNTS}${response?.data?.message ?? BLANK}`
                    }
                });
            }
        }).catch(err => {
            setmsg({
                type: "setMessage",
                payload: {
                    ...msg,
                    open: true,
                    type: "error",
                    message: `${MSG.ERR_GET_ACCOUNTS}${err?.errmsg ?? BLANK}`
                }
            });
        }).finally(() => {
            setProgress(false);
        });
    }, []);

    // キャンペーン一覧取得
    useEffect(() => {
        setProgress(true);
        const parentIds = campaignList.map(v => v.parentId)
        const noneGetIds = selectedAccounts.filter(value => !parentIds.includes(value))
        if (noneGetIds.length === 0) {
            setProgress(false);
            return
        }
        const values = noneGetIds[0]
        const pathAccount = `${apollo_operation_history_campagine_names}/${values}`;

        ApolloAxios.get(pathAccount).then(response => {
            if (response.data.resultCode === RESULT_KBN.SUCCESS) {
                setCampaignList(
                    campaignList.concat(response.data.result ?? [])
                )
            } else {
                setmsg({
                    type: "setMessage",
                    payload: {
                        ...msg,
                        open: true,
                        type: "error",
                        message: `${MSG.ERR_GET_CAMPAIGNS}${response?.data?.message ?? BLANK}`
                    }
                });
            }
        }).catch(err => {
            setmsg({
                type: "setMessage",
                payload: {
                    ...msg,
                    open: true,
                    type: "error",
                    message: `${MSG.ERR_GET_CAMPAIGNS}${err?.errmsg ?? BLANK}`
                }
            });
        }).finally(() => {
            setProgress(false);
        });
    }, [selectedAccounts]);

    // 広告グループ一覧取得
    useEffect(() => {
        setProgress(true);
        const parentIds = adGroupList.map(v => `${v.platform}${UNDER_SCORE}${v.parentId}`)
        const noneGetIds = selectedCampaigns.filter(value => !parentIds.includes(value))
        if (noneGetIds.length === 0) {
            setProgress(false);
            return
        }
        const values = noneGetIds[0].split(UNDER_SCORE)
        const accountId = campaignList.filter(v => `${v.platform}${UNDER_SCORE}${v.id}` === noneGetIds[0])[0].platformAccountId
        const pathAccount = `${apollo_operation_history_adgroup_names}${SLASH}${values[0]}${SLASH}${accountId}${SLASH}${values[1]}`;

        ApolloAxios.get(pathAccount).then(response => {
            if (response.data.resultCode === RESULT_KBN.SUCCESS) {
                setAdGroupList(
                    adGroupList.concat(response.data.result ?? [])
                )
            } else {
                setmsg({
                    type: "setMessage",
                    payload: {
                        ...msg,
                        open: true,
                        type: "error",
                        message: `${MSG.ERR_GET_ADGROUPS}${response?.data?.message ?? BLANK}`
                    }
                });
            }
        }).catch(err => {
            setmsg({
                type: "setMessage",
                payload: {
                    ...msg,
                    open: true,
                    type: "error",
                    message: `${MSG.ERR_GET_ADGROUPS}${err?.errmsg ?? BLANK}`
                }
            });
        }).finally(() => {
            setProgress(false);
        });
    }, [selectedCampaigns]);

    const clickButtonSearch = () => {
        buttonType.current = BUTTON_SEARCH
    }

    const clickButtonDownLoad = () => {
        buttonType.current = BUTTON_CSV_DOWNLOAD
    }

    const onSubmit = handleSubmit(async (formData: any) => {
        const dateFrom = moment(startDate)
        const dateTo = moment(endDate).endOf(CHAR_DAY)
        const todayStart = moment(TARGET_MAX_DAY).startOf(CHAR_DAY)
        const todayEnd = moment(TARGET_MAX_DAY).endOf(CHAR_DAY)

        if (dateFrom.diff(todayStart) > 0) {
            setmsg({
                type: "setMessage",
                payload: {
                    ...msg,
                    open: true,
                    type: "error",
                    message: `開始日は、当日以前を指定して下さい。`
                }
            });
            return
        }

        setProgress(true);

        const formatStartDate = (dateFrom.diff(todayStart) > 0 ? todayStart : dateFrom).format(TIME_FORMAT_PATTERN2).replace(SPACE, TIME_ENDCHAR);
        const formatEndDate = (dateTo.diff(todayEnd) > 0 ? todayEnd : dateTo).format(TIME_FORMAT_PATTERN2).replace(SPACE, TIME_ENDCHAR);

        const categoryTarget = CATEGORY[category]?.TARGET ?? BLANK

        const accountIds = selectedAccounts.join() ?? BLANK
        const campaignIds = selectedCampaigns.map((value: any) => value.slice(2))?.join() ?? BLANK
        const adGroupIds = selectedAdGroups.map((value: any) => value.slice(2))?.join() ?? BLANK

        const requestParams = `?startDateTime=${formatStartDate}&` +
            `endDateTime=${formatEndDate}&` +
            `accountGroupId=${apolloContex.current.accountGroupId}&` +
            `accountId=${accountIds}&` +
            `campaignId=${campaignIds}&` +
            `adGroupId=${adGroupIds}&` +
            `categoryKbn=${category}&`
        // ユーザ操作ログ取得
        const fetchUserLogs = async () => {
            const url = `${process.env.REACT_APP_API_ENDPOINT}${apollo_operation_log}/${requestParams}`
            await ApolloAxios.get(
                url,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${apolloContex.accesstoken}`,
                    }
                }
            ).then((response) => {
                if (response.data.resultCode === RESULT_KBN.SUCCESS) {
                    const rowItems = response.data.result?.map((elem: any) => {
                            const items = elem.itemList.filter((item: any) => item?.beforeValue !== item?.afterValue).map((item: any) => (
                                {
                                    columName: item.key,
                                    beforeValue: item?.beforeValue ?? BLANK,
                                    afterValue: item?.afterValue ?? BLANK,
                                }
                            ))
                            return {
                                date: elem.eventDate,
                                name: elem.userName,
                                accountName: elem.accountName ?? HYPHEN,
                                pfmenu: elem.menu,
                                campaignName: elem.campaignName || HYPHEN,
                                adGroupName: elem.adGroupName || HYPHEN,
                                target: elem.category,
                                operationKbn: elem.actionType,
                                targetColumns: elem.itemList.filter((item: any) => item?.beforeValue !== item?.afterValue).map((item: any) => (item.key)).join(FULL_COMMA),
                                editDetails: items,
                            }
                        }
                    ) ?? []

                    if (buttonType.current === BUTTON_SEARCH) {
                        setRows(rowItems)
                    } else if (buttonType.current === BUTTON_CSV_DOWNLOAD) {
                        createCsv(rowItems, category)
                    }
                } else if (response.data.resultCode === RESULT_KBN.ERROR) {
                    setmsg({
                        type: "setMessage",
                        payload: {
                            ...msg,
                            open: true,
                            type: "error",
                            message: `${MSG.ERR_GET_OPERATONLOGS}${response?.data?.message ?? BLANK}`
                        }
                    });
                } else if (response.data.resultCode === RESULT_KBN.BADREQUEST) {
                    setmsg({
                        type: "setMessage",
                        payload: {
                            ...msg,
                            open: true,
                            type: "error",
                            message: `${MSG.ERR_GET_OPERATONLOGS}${response?.data?.message ?? BLANK}`
                        }
                    });
                }
            }).catch(err => {
                setmsg({
                    type: "setMessage",
                    payload: {
                        ...msg,
                        open: true,
                        type: "error",
                        message: `${MSG.ERR_GET_OPERATONLOGS}${err?.errmsg ?? BLANK}`
                    }
                });
            }).finally(() => {
                setProgress(false);
            });
        };
        fetchUserLogs();
    })

    React.useEffect(() => {
    }, [optionsAdGroupList]);

    const listOptions = {
        selectableRowsHeader: true,
        filter: true,
        sortOrder: localStorage.getItem(STORAGE_KEY.MS_AD_GROUP_LIST) ? undefined : sortOrder,
        viewColumns: false,
        download: false,
        print: false,
        sort: true,
        search: true,
        rowsPerPageOptions: [5, 10, 20],
        jumpToPage: true,
        selectableRowsHideCheckboxes: true,
        storageKey: STORAGE_KEY.OPERATION_HISTORY,
        rowsPerPage: numberOfRows,
        onColumnSortChange: (changedColumn: string, direction: string) => {
            setSortOrder({
                name: changedColumn,
                direction: direction,
            } as MUISortOptions)
        },
        onChangeRowsPerPage: (numberOfRows: number) => setNumberOfRows(numberOfRows),
        customToolbarSelect: () => undefined,
        expandableRows: true,
        expandableRowsHeader: true,
        expandableRowsOnClick: true,
        isRowExpandable: (dataIndex: number, expandedRows: any) => {

            const target = rows[dataIndex]
            const isDiff = target?.editDetails.filter((elem : editDetail) =>
                elem.beforeValue !== elem.afterValue
            )?.length !== 0

            return target?.operationKbn === OPERATION_KBN.update && isDiff;
        },
        renderExpandableRow: (rowData: any, rowMeta: { rowIndex: number, dataIndex: number }) => {
            const colspan = rowData.length + 1;
            return rows[rowMeta.dataIndex].operationKbn === OPERATION_KBN.update ?
                <TableRow>
                    <TableCell colSpan={colspan}>
                        <TableContainer component={Paper} square variant="outlined">
                            <Table size="small" aria-label="purchases">
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={{width: "20%"}}>項目名</TableCell>
                                        <TableCell style={{width: "40%"}}>変更前</TableCell>
                                        <TableCell style={{width: "40%"}}>変更後</TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {rows[rowMeta.dataIndex].editDetails.map(((detail) =>
                                            <TableRow>
                                                <TableCell component="th" scope="row">
                                                    {detail.columName}
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    {convertBrTag(detail.beforeValue)}
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    {convertBrTag(detail.afterValue)}
                                                </TableCell>
                                            </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </TableCell>
                </TableRow>
                : <></>;
        },
    }

    return (
        <GenericTemplate title="">
            <Backdrop className={classes.backdrop2} open={progress}>
                <Bars color="#00BFFF" height={80} width={80}/>
            </Backdrop>
            <CustomizedSnackbars/>
            <ApolloPageUsagePermission role={APOLLO_GROUP_OPERATOR} profile={APOLLO_PROFILE_SYSTEM_OPERATOR}>
                <ApolloBreadcrumbs bread_no={75} zeusaccountid={0} zeuscampaignid={0} adgroupid={0} adid={0} query={""}
                                   platform={""}/>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <form onSubmit={onSubmit}>
                            <Card className={classes.root}>
                                <CardContent>
                                    <Grid container spacing={3}>
                                        <Grid item xs={6}>
                                            <ApolloBasicSelect
                                                id={"category"}
                                                label="対象機能"
                                                options={selectCategoryFiltered.current}
                                                value={category}
                                                control={control}
                                                errors={errors}
                                                rules={{
                                                    required: "必須入力項目です。",
                                                }}
                                                setState={(e: any) => {
                                                    setRows([])
                                                    setCategory(e)
                                                }
                                                }
                                                setValue={(name: string, value: any) => setValue(name, value)}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                        </Grid>
                                        {category === KBN_2 || category === KBN_3 ? <>
                                            <Grid item xs={6}>
                                                <ApolloBasicSelect
                                                    id={"accountNameList"}
                                                    label="広告アカウント名"
                                                    options={optionsAccountList}
                                                    isMulti={true}
                                                    value={selectedAccounts}
                                                    control={control}
                                                    errors={errors}
                                                    closeMenuOnSelect={false}
                                                    rules={{
                                                        required: "必須入力項目です。",
                                                    }}

                                                    setState={(e: any) => {
                                                        const setVals = e ? e.map((target: any) => {
                                                            return target.value
                                                        }) : []
                                                        setSelectedAccounts(setVals)

                                                        const selectedAccountIds = setVals
                                                        const valideCampainIds = campaignList.filter((list: any) => selectedAccountIds.includes(list.parentId)).map((list: any) => list.platform + UNDER_SCORE + list.id)
                                                        const valideAccountGrpIds = adGroupList.filter((list: any) => valideCampainIds.includes(list.platform + UNDER_SCORE + list.parentId)).map((list: any) => list.platform + UNDER_SCORE + list.id)

                                                        const valuse2 = selectedCampaigns.filter((list: any) => valideCampainIds.includes(list))
                                                        setSelectedCampaigns(valuse2)

                                                        const valuse3 = selectedAdGroups.filter((list: any) => valideAccountGrpIds.includes(list))
                                                        setSelectedAdGroups(valuse3)

                                                    }}
                                                    setValue={(name: string, value: any) => setValue(name, value)}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                            </Grid>
                                        </> : <></>}
                                        {category === KBN_2 ? <>
                                            <Grid item xs={6}>
                                                <ApolloBasicSelect
                                                    id={"campaignNameList"}
                                                    label="キャンペーン名"
                                                    options={optionsCampaignList}
                                                    isMulti={true}
                                                    value={selectedCampaigns}
                                                    control={control}
                                                    errors={errors}
                                                    closeMenuOnSelect={false}
                                                    setState={(e: any) => {

                                                        const setVals = e ? e.map((target: any) => {
                                                            return target.value
                                                        }) : []
                                                        setSelectedCampaigns(setVals)
                                                        const selectedCampainIds = setVals
                                                        const valideAccountGrpIds = adGroupList.filter((list: any) => selectedCampainIds.includes(list.platform + UNDER_SCORE + list.parentId)).map((list: any) => list.platform + UNDER_SCORE + list.id)

                                                        const valuse3 = selectedAdGroups.filter((list: any) => valideAccountGrpIds.includes(list))
                                                        setSelectedAdGroups(valuse3)
                                                    }}
                                                    setValue={(name: string, value: any) => setValue(name, value)}
                                                    /*                                        disabled={disableTargeting}*/
                                                />
                                            </Grid>
                                        </> : <></>}
                                        {category === KBN_2 ? <>
                                            <Grid item xs={6}>
                                                <ApolloBasicSelect
                                                    id={"adGroupNameList"}
                                                    label="広告グループ名"
                                                    isMulti={true}
                                                    options={optionsAdGroupList}
                                                    value={selectedAdGroups}
                                                    control={control}
                                                    errors={errors}
                                                    closeMenuOnSelect={false}
                                                    setState={(e: any) => {
                                                        const setVals = e ? e.map((target: any) => {
                                                            return target.value
                                                        }) : []
                                                        setSelectedAdGroups(setVals)
                                                    }}
                                                    setValue={(name: string, value: any) => setValue(name, value)}
                                                />
                                            </Grid>
                                        </> : <></>}
                                        <Grid item xs={12}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12} md={4}>
                                                    <ApolloDateRangePicker
                                                        startDateLabel={"開始"}
                                                        startDate={startDate}
                                                        setStartDate={setStartDate}
                                                        startMinDate={TARGET_MIN_DAY}
                                                        endDateLabel={"終了"}
                                                        endDate={endDate}
                                                        setEndDate={setEndDate}

                                                    />
                                                </Grid>
                                                <Grid item xs={5}>
                                                </Grid>
                                                <Grid item xs={1}>
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        style={{whiteSpace: "nowrap"}}
                                                        type="submit"
                                                        onClick={clickButtonSearch}
                                                    >
                                                        検索
                                                    </Button>
                                                </Grid>
                                                <Grid item xs={1}>

                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={clickButtonDownLoad}
                                                        style={{whiteSpace: "nowrap"}}
                                                        type="submit"
                                                    >
                                                        CSVダウンロード
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </form>
                        <Card className={classes.root} square variant="outlined">
                            <MuiThemeProvider theme={tableTheme}>
                                <MUIDataTable
                                    title="ユーザ操作履歴一覧"
                                    data={rows}
                                    columns={CATEGORY[category]?.TABLE_OPTIONS}
                                    options={createApolloPageSizeTableOptions(listOptions, APOLLO_PAGE_ID.OPERATION_HISTORY)}
                                />
                            </MuiThemeProvider>
                        </Card>
                    </Grid>
                </Grid>
            </ApolloPageUsagePermission>
        </GenericTemplate>
    );
};

export default OperationHistoryList;
